// Remove the <script> tags when saving as a .js file
document.addEventListener('DOMContentLoaded', function () {
  // Get references to elements
  const tabButtons = document.querySelectorAll('.tab-btn');
  const speakerItems = document.querySelectorAll('.speaker-item');
  const categoryIntros = document.querySelectorAll('.category-intro');

  // Tab click handler
  function handleTabClick(event) {
    // Update tab states
    tabButtons.forEach(btn => {
      btn.classList.remove('active');
      btn.setAttribute('aria-pressed', 'false');
    });

    // Set active tab
    this.classList.add('active');
    this.setAttribute('aria-pressed', 'true');

    // Get category from data attribute
    const category = this.getAttribute('data-category');

    // Hide all category intros
    categoryIntros.forEach(intro => {
      intro.style.display = 'none';
    });

    // Show relevant category intro
    if (category !== 'all') {
      const introElement = document.getElementById(`intro-${category}`);
      if (introElement) {
        introElement.style.display = 'block';
      }
    }

    // Filter speaker items
    speakerItems.forEach(item => {
      if (category === 'all') {
        item.style.display = '';
      } else {
        const categories = item.getAttribute('data-categories');
        item.style.display = categories.includes(category) ? '' : 'none';
      }
    });
  }

  // Initialize - hide all category intros
  categoryIntros.forEach(intro => {
    intro.style.display = 'none';
  });


  // Add to your speaker-tabs.js
function setupKeyboardNavigation() {
  const tabsList = document.querySelector('.tabs-nav');
  if (!tabsList) return;
  
  tabsList.addEventListener('keydown', function(e) {
    // If not a tab button or not an arrow key, do nothing
    if (!e.target.classList.contains('tab-btn') || 
        (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
    
    e.preventDefault();
    
    const tabs = Array.from(tabsList.querySelectorAll('.tab-btn'));
    const currentIndex = tabs.indexOf(e.target);
    
    // Determine which tab to focus next
    let nextIndex;
    if (e.key === 'ArrowLeft') {
      nextIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
    } else {
      nextIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
    }
    
    // Focus and click the next tab
    tabs[nextIndex].focus();
    tabs[nextIndex].click();
  });
}

// Call this function on DOMContentLoaded
setupKeyboardNavigation();

  function debounce(func, wait = 100) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
  }
  
  // Wrap your tab click handler
const debouncedHandleClick = debounce(handleTabClick);
tabButtons.forEach(button => {
  button.addEventListener('click', debouncedHandleClick);
});
  
});